import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, MenuItem } from "@mui/material";

import {
  EventContainer,
  FormGrid,
  Card,
  CardTitle,
  InputGroup,
  InputLabel,
  Textarea,
} from "./styles";

export default function DetalhesOportunidade({ oportunidadeData, setOportunidadeData }) {
  // -------------------- CONTATOS ------------------------
  const contatos =
    oportunidadeData.contatos && oportunidadeData.contatos.length > 0
      ? oportunidadeData.contatos
      : [
          {
            id: Date.now() + Math.random(),
            telefone: "",
            email: "",
            redeSocial: "",
          },
        ];

  if (!oportunidadeData.contatos || oportunidadeData.contatos.length === 0) {
    setTimeout(() => {
      setOportunidadeData({ ...oportunidadeData, contatos });
    }, 0);
  }

  const handleContatoChange = (id, field, value) => {
    const novos = (oportunidadeData.contatos || []).map((c) =>
      c.id === id ? { ...c, [field]: value } : c
    );
    setOportunidadeData({ ...oportunidadeData, contatos: novos });
  };

  const handleAdicionarContato = () => {
    const novo = {
      id: Date.now() + Math.random(),
      telefone: "",
      email: "",
      redeSocial: "",
    };
    setOportunidadeData({
      ...oportunidadeData,
      contatos: [...(oportunidadeData.contatos || []), novo],
    });
  };

  const handleRemoverContato = (id) => {
    const novos = (oportunidadeData.contatos || []).filter((c) => c.id !== id);
    if (novos.length === 0) {
      const empty = {
        id: Date.now() + Math.random(),
        telefone: "",
        email: "",
        redeSocial: "",
      };
      setOportunidadeData({ ...oportunidadeData, contatos: [empty] });
    } else {
      setOportunidadeData({ ...oportunidadeData, contatos: novos });
    }
  };

  // -------------------- CONTEÚDOS ------------------------
  const conteudos =
    oportunidadeData.conteudos && oportunidadeData.conteudos.length > 0
      ? oportunidadeData.conteudos
      : [{ titulo: "", itens: [""] }];

  if (!oportunidadeData.conteudos || oportunidadeData.conteudos.length === 0) {
    setTimeout(() => {
      setOportunidadeData({ ...oportunidadeData, conteudos });
    }, 0);
  }

  const updateTitulo = (index, value) => {
    const novos = [...oportunidadeData.conteudos];
    novos[index].titulo = value;
    setOportunidadeData({ ...oportunidadeData, conteudos: novos });
  };

  const updateItem = (cIndex, iIndex, value) => {
    const novos = [...oportunidadeData.conteudos];
    novos[cIndex].itens[iIndex] = value;
    setOportunidadeData({ ...oportunidadeData, conteudos: novos });
  };

  const addItem = (cIndex) => {
    const novos = [...oportunidadeData.conteudos];
    novos[cIndex].itens.push("");
    setOportunidadeData({ ...oportunidadeData, conteudos: novos });
  };

  const removeItem = (cIndex, iIndex) => {
    const novos = [...oportunidadeData.conteudos];
    novos[cIndex].itens.splice(iIndex, 1);
    if (novos[cIndex].itens.length === 0) novos[cIndex].itens = [""];
    setOportunidadeData({ ...oportunidadeData, conteudos: novos });
  };

  const addBloco = () => {
    setOportunidadeData({
      ...oportunidadeData,
      conteudos: [...oportunidadeData.conteudos, { titulo: "", itens: [""] }],
    });
  };

  const removerBloco = (index) => {
    const novos = oportunidadeData.conteudos.filter((_, i) => i !== index);
    setOportunidadeData({
      ...oportunidadeData,
      conteudos: novos.length ? novos : [{ titulo: "", itens: [""] }],
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <EventContainer>
        <FormGrid>
          {/* ----------------- DETALHES PRINCIPAIS ------------------ */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Detalhes da Oportunidade</CardTitle>

            <InputGroup>
              <InputLabel>Título *</InputLabel>
              <TextField
                fullWidth
                placeholder="Título da oportunidade"
                value={oportunidadeData.titulo}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, titulo: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Descrição</InputLabel>
              <Textarea
                placeholder="Descreva a oportunidade..."
                value={oportunidadeData.descricao}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, descricao: e.target.value })
                }
              />
            </InputGroup>
            <InputGroup>
  <InputLabel>Organizador</InputLabel>
  <TextField
    fullWidth
    placeholder="Nome do organizador"
    value={oportunidadeData.organizador}
    onChange={(e) =>
      setOportunidadeData({ ...oportunidadeData, organizador: e.target.value })
    }
  />
</InputGroup>


            <InputGroup>
              <InputLabel>Empresa *</InputLabel>
              <TextField
                fullWidth
                placeholder="Nome da empresa"
                value={oportunidadeData.empresa}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, empresa: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Cargo *</InputLabel>
              <TextField
                fullWidth
                placeholder="Cargo ou função"
                value={oportunidadeData.cargo}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, cargo: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Status</InputLabel>
              <TextField
                select
                fullWidth
                value={oportunidadeData.status || "Upcoming"}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, status: e.target.value })
                }
              >
                <MenuItem value="Upcoming">Próximo</MenuItem>
                <MenuItem value="Ongoing">Em andamento</MenuItem>
                <MenuItem value="Completed">Finalizado</MenuItem>
                <MenuItem value="Canceled">Cancelado</MenuItem>
              </TextField>
            </InputGroup>

            <InputGroup>
              <InputLabel>Salário</InputLabel>
              <TextField
                fullWidth
                placeholder="Ex: R$ 2.000,00"
                value={oportunidadeData.salario}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, salario: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Hora de trabalho</InputLabel>
              <TextField
                fullWidth
                placeholder="Ex: 08:00 - 17:00"
                value={oportunidadeData.horaTrabalho}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, horaTrabalho: e.target.value })
                }
              />
            </InputGroup>

            <FormGrid columns="2">
              <InputGroup>
                <InputLabel>Data de Início *</InputLabel>
                <DatePicker
                  value={oportunidadeData.dataInicio}
                  onChange={(date) =>
                    setOportunidadeData({ ...oportunidadeData, dataInicio: date })
                  }
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              <InputGroup>
                <InputLabel>Data de Término *</InputLabel>
                <DatePicker
                  value={oportunidadeData.dataFim}
                  onChange={(date) =>
                    setOportunidadeData({ ...oportunidadeData, dataFim: date })
                  }
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                />
              </InputGroup>
            </FormGrid>

            <InputGroup>
              <InputLabel>Local</InputLabel>
              <TextField
                fullWidth
                placeholder="Local da oportunidade"
                value={oportunidadeData.local}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, local: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Sobre a Empresa</InputLabel>
              <Textarea
                placeholder="Informações sobre a empresa"
                value={oportunidadeData.sobreEmpresa}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, sobreEmpresa: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup style={{ marginTop: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="checkbox"
                  checked={oportunidadeData.destacado}
                  onChange={(e) =>
                    setOportunidadeData({ ...oportunidadeData, destacado: e.target.checked })
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span>Destacar oportunidade</span>
              </label>
            </InputGroup>

            <InputGroup style={{ marginTop: "20px" }}>
              <InputLabel>Número de vagas</InputLabel>
              <TextField
                type="number"
                fullWidth
                placeholder="Ex: 10"
                value={oportunidadeData.vagas || ""}
                onChange={(e) =>
                  setOportunidadeData({ ...oportunidadeData, vagas: e.target.value })
                }
              />
            </InputGroup>
          </Card>

          {/* ---------------------- CONTATOS ---------------------- */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Contatos da Oportunidade</CardTitle>

            {(oportunidadeData.contatos || []).map((contato) => (
              <div
                key={contato.id}
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "12px",
                  alignItems: "flex-start",
                }}
              >
                <TextField
                  label="Telefone"
                  fullWidth
                  value={contato.telefone}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "telefone", e.target.value)
                  }
                />
                <TextField
                  label="Email"
                  fullWidth
                  value={contato.email}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "email", e.target.value)
                  }
                />
                <TextField
                  label="Rede Social (link)"
                  fullWidth
                  value={contato.redeSocial}
                  onChange={(e) =>
                    handleContatoChange(contato.id, "redeSocial", e.target.value)
                  }
                />
                {(oportunidadeData.contatos || []).length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoverContato(contato.id)}
                    style={{
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      height: "fit-content",
                    }}
                  >
                    Remover
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={handleAdicionarContato}
              style={{
                marginTop: "10px",
                padding: "10px 14px",
                borderRadius: "8px",
                border: "none",
                background: "#2563eb",
                color: "white",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              Adicionar contato
            </button>
          </Card>

          {/* ---------------------- CONTEÚDOS ---------------------- */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Conteúdos da Oportunidade</CardTitle>

            {conteudos.map((conteudo, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "20px",
                }}
              >
                <TextField
                  label="Título do conteúdo"
                  fullWidth
                  value={conteudo.titulo}
                  onChange={(e) => updateTitulo(index, e.target.value)}
                  style={{ marginBottom: "12px" }}
                />

                <strong>Itens</strong>
                {conteudo.itens.map((item, iIndex) => (
                  <div
                    key={iIndex}
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      placeholder={`Item ${iIndex + 1}`}
                      fullWidth
                      value={item}
                      onChange={(e) => updateItem(index, iIndex, e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => removeItem(index, iIndex)}
                      style={{
                        background: "#dc2626",
                        color: "#fff",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      X
                    </button>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={() => addItem(index)}
                  style={{
                    padding: "8px 12px",
                    background: "#2563eb",
                    borderRadius: "6px",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    marginBottom: "12px",
                  }}
                >
                  + Adicionar item
                </button>

                {conteudos.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removerBloco(index)}
                    style={{
                      padding: "8px 12px",
                      background: "#dc2626",
                      borderRadius: "6px",
                      color: "#fff",
                      border: "none",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    Remover bloco
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={addBloco}
              style={{
                padding: "10px 14px",
                background: "#059669",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              + Adicionar novo conteúdo
            </button>
          </Card>
        </FormGrid>
      </EventContainer>
    </LocalizationProvider>
  );
}
